module.exports = "# 错误码说明\n## 全局错误返回码说明\n| 错误码      |    说明 |\n| :-------- | --------| \n| 0040005| \t缺少请求参数\n| 0040301| \t签名错误\n| 0040302|\tclient_id 错误\n| 0040303| \t应用的key已过期\n| 0040304| \t应用secret错误\n| 0040305| \t应用错误\n| 0040306| \t应用无效\n| 0040307| \t签名时间戳格式无效  \n| 0040308| \t签名时间戳超过有效范围\n| 0040309| \t该应用无权权限调用此API\n| 0040310| \t需要传入正确的用户token  \n| 0040311| \t请求次数超出单位时间调用频次限制 \n| 0040312| \t用户密码校验错误 \n| 0040400| \tAPI不存在\n| 0040401| \tAPI方法不存在 \n| 0050400| \t后端错误"


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/guide/errcode.md
 ** module id = 590
 ** module chunks = 1
 **/